import { Options } from 'highcharts';

export const STATISTICS_CHART_CONFIG: Options = {
  title: {
    text: '',
  },
  tooltip: { enabled: false },
  xAxis: {
    visible: true,
  },
  yAxis: {
    visible: false,
    startOnTick: false,
    endOnTick: false,
    maxPadding: 0.2,
    height: '94%',
  },
  plotOptions: {
    spline: {
      lineWidth: 2,
      marker: {
        enabled: false,
        symbol: 'circle',
      },
    },
    series: {
      animation: false,
      states: {
        hover: {
          enabled: false,
        },
        inactive: {
          opacity: 1,
        },
      },
    },
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  chart: {
    animation: false,
    marginLeft: 16,
    marginRight: 16,
    type: 'spline',
    backgroundColor: '#1C1C1F',
    plotBackgroundColor: '#2B2B2E',
    height: '124px',
    spacing: [0, 0, 0, 0],
    style: {
      fontFamily: "'Nunito Sans', sans-serif",
      fontSize: '10px',
      fontWeight: '600',
    },
  },
};

export const STATISTICS_LINES_COLORS = {
  membership: [
    [0, '#2EC7E6'],
    [1, '#2E8AE6'],
  ],
  sponsors: [
    [0, '#619DF2'],
    [1, '#505DE6'],
  ],
  messages: [
    [0, '#FFC44D'],
    [1, '#FF8040'],
  ],
  referrals: [
    [0, '#99CC66'],
    [1, '#56BF56'],
  ],
  staking: [
    [0, '#AA61F2'],
    [1, '#6950E6'],
  ],
  tips: [
    [0, '#F26F55'],
    [1, '#E64560'],
  ],
  bundles: [
    [0, '#AA61F2'],
    [1, '#6950E6'],
  ],
};

export const STATISTICS_MONTHS_NUMS = [1, 7, 15, 22, 30];
